import { ReactNode } from "react";
import { Controller, FieldValues } from "react-hook-form";
import { Checkbox as PLOSCheckbox } from "../../Checkbox";
import { SharedControllerProps } from "../types";

interface CheckboxProps<
  T extends FieldValues = FieldValues,
> extends SharedControllerProps<T> {
  children: ReactNode;
}

const Checkbox = <T extends FieldValues = FieldValues>({
  control,
  label,
  name,
  rules,
  children,
  disabled = false,
}: CheckboxProps<T>) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field: { value, onBlur, onChange } }) => (
      <PLOSCheckbox
        name={name}
        isSelected={Boolean(value)}
        onChange={(isSelected) => onChange(isSelected)}
        onBlur={onBlur}
        isRequired={!!rules?.required}
        aria-label={label}
        isDisabled={disabled}
      >
        {children}
      </PLOSCheckbox>
    )}
  />
);

export default Checkbox;
